const muiStyles = () => ({
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    submitButton: {
        alignSelf: 'center',
        marginTop: '2.5rem'
    },
    submitError: { alignSelf: 'center' }
});

export default muiStyles;